/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PalReauthReportGenerationState = {
    Created: 'created',
    InProgress: 'in_progress',
    Finished: 'finished',
    Error: 'error'
} as const;
export type PalReauthReportGenerationState = typeof PalReauthReportGenerationState[keyof typeof PalReauthReportGenerationState];


export function PalReauthReportGenerationStateFromJSON(json: any): PalReauthReportGenerationState {
    return PalReauthReportGenerationStateFromJSONTyped(json, false);
}

export function PalReauthReportGenerationStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthReportGenerationState {
    return json as PalReauthReportGenerationState;
}

export function PalReauthReportGenerationStateToJSON(value?: PalReauthReportGenerationState | null): any {
    return value as any;
}

